/* RESPONSIBLE TEAM: team-messenger */
import Model, { attr } from '@ember-data/model';

export default class MessengerHomeArticleSuggestionPreviewModel extends Model {
  @attr userSuggestions;
  @attr visitorSuggestions;
}
